import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { PaymentState } from './state';

const getters: GetterTree<PaymentState, RootState> = {
  flagOptions: (state, getters) => {
    return state.flagOptions;
  },
  monthOptions: (state, getters) => {
    return state.monthOptions;
  },
  yearOptions: (state, getters) => {
    return state.yearOptions;
  },
  getCreditCard: (state, getters) => {
    return state.creditCard;
  },
  paymentValue: (state, getters) => {
    return state.paymentValue;
  },
  bankSlipFile: (state, getters) => {
    return state.bankSlipFile;
  },
  pixData: (state, getters) => {
    return state.pixData;
  },
  showPixQrCode: (state, getters) => {
    return state.pixData.showPixQrCode;
  },
  isPixCodeExpired: (state, getters) => {
    return state.pixData.isPixCodeExpired;
  },
  currentPaymentMethod: (state, getters) => {
    return state.currentPaymentMethod;
  },
  isRecurrentCreditCard: (state, getters) => state.isRecurrentCreditCard,
};

export default getters;
